import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDiscord,
  faInstagram,
  faTwitter,
} from '@soundxyz/font-awesome/free-brands-svg-icons/index.mjs';
import { faStore } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { styled, theme } from '@components-shared/src/stitches';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { Mirror } from '@components/main-components/media/icons/Mirror';
import { EXTERNAL_PATHS } from '@utils/constants';

export const FooterIcons = () => (
  <FooterIconsContainer>
    <AccessibleLink absoluteUri={EXTERNAL_PATHS.Twitter} type="external">
      <FontAwesomeIcon icon={faTwitter} size="xl" />
    </AccessibleLink>
    <AccessibleLink absoluteUri={EXTERNAL_PATHS.Instagram} type="external">
      <FontAwesomeIcon icon={faInstagram} size="xl" />
    </AccessibleLink>
    <AccessibleLink absoluteUri={EXTERNAL_PATHS.Discord} type="external">
      <FontAwesomeIcon icon={faDiscord} size="xl" />
    </AccessibleLink>
    <AccessibleLink absoluteUri={EXTERNAL_PATHS.Blog} type="external">
      <Mirror fill={theme.colors.neutral400.value} />
    </AccessibleLink>
    <AccessibleLink absoluteUri={EXTERNAL_PATHS.Market} type="external">
      <FontAwesomeIcon icon={faStore} size="xl" />
    </AccessibleLink>
  </FooterIconsContainer>
);

const FooterIconsContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  columnGap: 24,
  alignItems: 'center',
  color: '$neutral400',
});
